import { AuthGate } from '@/components/ProtectedApp';
import { useRoles } from '@/hooks/useRoles';
import type { AppRole } from '@/utils/auth';
import type { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface RequireRoleProps {
  requiredRole: AppRole;
  children: ReactNode;
}

/** Renders the children only for users holding the required role; others see a quiet refusal card. */
export const RequireRole: FC<RequireRoleProps> = ({ requiredRole, children }) => {
  const { roles } = useRoles();
  const { t } = useTranslation();

  if (!roles.includes(requiredRole)) {
    return <AuthGate title={t('auth.adminOnlyTitle')} message={t('auth.adminOnlyMessage')} />;
  }
  return <>{children}</>;
};
